<template>
    <button class="btn--icon">
        <svg class="icon">
            <use xmlns:xlink="http://www.w3.org/1999/xlink" :xlink:href="icon" />
        </svg>
    </button>
</template>
<script>
export default {
  name: 'btn-icon-close',
  props: {
    icon_name: {
      type: String,
    },
  },
  computed: {
    icon() {
      return 'icons/sprite.svg#'+this.icon_name;
    },
  },
};
</script>

<style scoped>
.btn--icon:hover .icon {
  color: #e2173d;
}
</style>
